














import { defineComponent } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "AgeConfirmationDeclined",
  components: { BaseConfirm, BaseButton },
  setup() {
    const logout = () => emitter.emit(EVENTS.USER_LOGOUT);

    return { logout };
  },
});
